import DashboardTabMediator from "./DashboardTabMediator";
import StoryVariables from "../../../util/StoryVariables";

export default class DashboardRCCETabMediator extends DashboardTabMediator {
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, dashboardConfig, progressGameModel) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._dashboardConfig = dashboardConfig;
        this._progressGameModel = progressGameModel;
    }

    initialize() {
        super.initialize();
        const week = this._progressGameModel.week;
        const movieClipName = this._dashboardConfig.getRCCEMovieClipPerWeek(week);
        this._initializeImageContainer(movieClipName);
    }

    _initializeImageContainer(movieClipId) {
        this._target.imageContainer.removeAllChildren();
        const illustration = new lib.MainAssets[movieClipId];
        const illustrationSkin = this._target.imageContainer.addChild(illustration);
    }

    destroy() {
        super.destroy();
    }
    get skin() {
        return this._target;
    }
}